import React from "react";

import {Categorys} from "../components/Categorys";

export const CategorysPage = () => {
    return (
        <div>
            <Categorys />
        </div>
    )
}